import styled from "styled-components";

export const RedireccionContainer = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  background-color: var(--color-latex30);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: 10px 0;
  width: 100%;
`;

export const CruzContainer = styled.div`
  right: 6px;
  top: 0px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 44px;
  cursor: pointer;
  .line1 {
    border: 1px solid #fff;
    height: 20px;
    transform: rotate(45deg);
    width: 0px;
    background: #fff;
    position: absolute;
  }
  .line2 {
    border: 1px solid #fff;
    height: 20px;
    transform: rotate(-45deg);
    width: 0px;
    background: #fff;
    position: absolute;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  span {
    width: 50vh;
  }
  @media (max-width: 768px) {
    width: 320px;
    span {
      width: auto;
    }
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const ButtonRedireccion = styled.div`
  width: 108px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  .fa-spinner {
    animation: spin 1s linear infinite;
  }
`;

export const ButtonResetClave = styled(ButtonRedireccion)`
  width: 130px;
`;

export const TecladoWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
  background-color: var(--color-latex10);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TecladoInner = styled.div`
  width: 500px;
  max-width: 95vw;
  overflow: visible;
`;
